/**
 * Verkleinert ein Bild im Browser auf max. `maxKante` px Kantenlänge und
 * kodiert es als JPEG. Wirft, wenn das Ergebnis größer als `maxBytes` ist.
 * (siehe technical-design.md, Abschnitt 5 — zweistufige Größenbeschränkung)
 */
export async function bildVerkleinern(
  datei: File,
  { maxKante = 1920, qualitaet = 0.8, maxBytes = 5 * 1024 * 1024 } = {},
): Promise<Blob> {
  const erlaubt = ['image/jpeg', 'image/png', 'image/webp'];
  if (!erlaubt.includes(datei.type)) {
    throw new Error('Nur JPEG, PNG oder WebP erlaubt.');
  }

  const bitmap = await createImageBitmap(datei);
  const faktor = Math.min(1, maxKante / Math.max(bitmap.width, bitmap.height));
  const w = Math.round(bitmap.width * faktor);
  const h = Math.round(bitmap.height * faktor);

  const canvas = document.createElement('canvas');
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Canvas nicht verfügbar.');
  ctx.drawImage(bitmap, 0, 0, w, h);
  bitmap.close();

  const blob: Blob = await new Promise((res, rej) =>
    canvas.toBlob((b) => (b ? res(b) : rej(new Error('Bild konnte nicht erzeugt werden.'))), 'image/jpeg', qualitaet),
  );

  if (blob.size > maxBytes) {
    throw new Error(
      `Das Foto ist auch nach dem Verkleinern zu groß (${(blob.size / 1024 / 1024).toFixed(1)} MB, erlaubt sind 5 MB).`,
    );
  }
  return blob;
}
